// extracted by mini-css-extract-plugin
export default {"link":"LoginForm_link__Fj0CA","formText":"LoginForm_formText__u-mYu","passwordEditor":"LoginForm_passwordEditor__9eqVo","showHiddenIcon":"LoginForm_showHiddenIcon__Kbgpz"};